<template>
  <div>
    <component v-if="tag === 'a'" :class="classes" v-bind:is="tag" :href="computedURL">
      <slot></slot>
    </component>
    <component
      v-if="tag === 'button'"
      :class="classes"
      v-bind:is="tag"
      :onclick="'window.location.href = \'' + computedURL + '\''"
    >
      <slot></slot>
    </component>
    <component
      v-if="tag === 'v-btn'"
      :class="classes"
      v-bind:is="tag"
      :onclick="'window.location.href = \'' + computedURL + '\''"
    >
      <slot></slot>
    </component>
    <component
      v-if="tag === 'img'"
      :class="classes"
      v-bind:is="tag"
      :src="computedURL"
      :width="width"
      :height="height"
      :onclick="'window.location.href = \'' + computedURL + '\''"
    >
      <slot></slot>
    </component>
    <iframe
      v-if="tag === 'iframe'"
      v-bind:is="tag"
      :src="computedURL"
      :width="width"
      :height="height"
    ></iframe>
    <!--pdf v-if="tag === 'pdf'" v-bind:is="tag" :src="computedURL">
      <slot></slot>
    </pdf-->
    <component v-else :class="classes" v-bind:is="tag">{{ computedURL }}</component>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    url: String, // url="http://"
    handle: {
      type: String,
      default: "1234"
    },
    apikey: String,
    policy: String,
    signature: String,
    embed: Boolean,
    classes: String,
    output: String,
    tag: {
      type: String,
      default: "a"
    },
    width: String,
    height: String
  },
  computed: {
    security() {
      if (this.readpolicy !== undefined && this.signature !== undefined) {
        return (
          "/security=policy:" +
          this.policy +
          ",signature:" +
          this.signature +
          "/"
        );
      } else {
        return null;
      }
    },
    computedURL() {
      var url = this.url;
      
      if (this.apikey !== undefined) {
        url = url + this.apikey;
      }
      if (this.output === "pdf") {
        url = url + "/output=f:pdf";
      }
      // if this.output
      if (this.security !== null) {
        url = url + this.security;
      }
      url = url + this.handle;
      // console.log("handle: " + this.handle);
     // return url;
      // console.log("URL: "+ this.url);
      var returnUrl  = this.url + this.apikey  + "/security=policy:" + this.policy + ",signature:" + this.signature + "/" + this.handle;
             // console.log("Return url: " + returnUrl);

       return returnUrl;
    },
    iframeURL() {
      return (
        "https://docs.google.com/viewer?url=" +
        this.computedURL +
        "&embedded=true"
      );
    }
  }
};
</script>

<style>
</style>
